import React from 'react';
import { Neo, NeoGrid } from '@singularsystems/neo-react';
import RawGenericExportMappingComponentVM from './RawGenericExportMappingComponentVM';
import { observer } from 'mobx-react';
import RawGenericExportMappingLookup from '../Models/Lookups/RawGenericExportMappingLookup';
import { TextConstants } from '../../../Common/TextConstants';
import ManageRawGenericExportMappingComponent from './ManageRawGenericExportMappingComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { GenericMappings } from '../../../AccessControl/Models/Commands/Security/Roles';

interface IRawGenericExportMappingComponentProps {
    viewModel: RawGenericExportMappingComponentVM;
    onCancel: () => void;
}

@observer
export default class RawGenericExportMappingComponent extends React.Component<IRawGenericExportMappingComponentProps> {
    public render() {
        var viewModel = this.props.viewModel;
        return (
            <>
                {(viewModel.taskRunner.isBusy) && <Loading />}
                {viewModel.showManageMappingsComponent &&
                    <ManageRawGenericExportMappingComponent
                        viewModel={viewModel.manageRawGenericMappingVM}
                        onSave={() => viewModel.saveGenericMapping()}
                        onCancel={() => viewModel.cancel()} />
                }
                {!viewModel.showManageMappingsComponent &&
                    <Neo.Card title={TextConstants.Titles.GenericExportMappings} className="m-1">
                        {viewModel.authorisationService.hasRole(GenericMappings.AddNew) &&
                            <div className="row pb-3">
                                <div className="col text-right">
                                    <Neo.Button
                                        size="sm" className="btn btn-default"
                                        variant="primary"
                                        onClick={() => viewModel.addNewGenericMapping()}>
                                        {TextConstants.Buttons.AddGenericMapping}
                                    </Neo.Button>
                                </div>
                            </div>
                        }
                        <>
                            <Neo.Form 
                                model={viewModel.rawGenericExportMappingSearchCriteria} 
                                onSubmit={() => viewModel.rawGenericExportMappingSearchCriteria.meta.searchCriteria.value === "" ? viewModel.pageManager.refreshData() : viewModel.clearSearch()}>
                                <Neo.FormGroup
                                    suppressLabel={true}
                                    bind={viewModel.rawGenericExportMappingSearchCriteria.meta.searchCriteria}
                                    placeholder={TextConstants.PlaceHolder.SearchGenericExportMappings}
                                    append={
                                        <Neo.Button className="btn-small" isSubmit variant="primary">
                                            <i className={`${viewModel.rawGenericExportMappingSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                        </Neo.Button>}
                                >
                                </Neo.FormGroup>
                            </Neo.Form>
                        </>
                        <div>
                            <Neo.Pager pageManager={viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show " }}>
                                <div className="horizontalScroll inner-container">
                                    {viewModel.pageManager.totalRecords > 0 &&
                                        <NeoGrid.Grid<RawGenericExportMappingLookup> className={"table-striped"}>
                                            {(item, meta) => (
                                                <NeoGrid.Row key={item.rawGenericExportMappingId} className="twoRowsPerGridItem">
                                                    <NeoGrid.Column display={meta.exportName} label={TextConstants.Labels.ExportReport} wrap="true" />
                                                    <NeoGrid.Column display={meta.columnName} label={TextConstants.Labels.TableColumnName} />
                                                    <NeoGrid.Column display={meta.displayName} label={TextConstants.Labels.ReportColumnName} colSpan={3} />
                                                    <NeoGrid.Column display={meta.isExcluded} />
                                                    <NeoGrid.ButtonColumn>
                                                    <Neo.Button
                                                        variant="primary" isOutline className="btn-small"
                                                        onClick={() => viewModel.editGenericMapping(item)}>
                                                        <i className="fa fa-edit" />
                                                    </Neo.Button>
                                                    </NeoGrid.ButtonColumn>
                                                </NeoGrid.Row>
                                            )}
                                        </NeoGrid.Grid>
                                    }
                                </div>
                            </Neo.Pager>
                        </div>
                        <div className="row customMarginTop29 float-left pr-3">                               
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Back}</Neo.Button>
                            </div>
                    </Neo.Card>
                }

            </>
        );
    }
}